import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'create';

const reducersKeys = {
  createLabelRequest: 'createLabelRequest',
  createLabelSuccess: 'createLabelSuccess',
  createLabelFailure: 'createLabelFailure',
};

const initialState = {
  showModal: false,
  created: false,
  loading: false,
  error: null,
};

const createLabel = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.createLabelRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.createLabelSuccess]: (state) => {
      state.loading = false;
      state.showModal = false;
      state.created = true;
    },
    [reducersKeys.createLabelFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    openLabelModal: (state) => {
      state.created = false;
      state.showModal = true;
    },
    closeLabelModal: (state) => {
      state.showModal = false;
    },
  },
});

export const labelCreateReducer = createReducerNames(name, reducersKeys);
export const { actions } = createLabel;

export default createLabel.reducer;
